import React from 'react';
import {priceWithTwoDecimals} from "../utils/cartUtils";

// TODO - fix the align bottom problem if needed to align the price element with buttons
// at the moment it is solved with small line height
class Price extends React.Component {
    render() {
        const currencySymbol = this.props.currencySymbol ? this.props.currencySymbol : "";
        let showCurrencySymbolAtStart = true;
        if(currencySymbol === "€"){
            showCurrencySymbolAtStart = false;
        }
        const formattedPrice = isNaN(this.props.price) ? this.props.price : priceWithTwoDecimals(this.props.price);
        const strikethrough = this.props.strikethrough ? " line-through" : "";

        // Unstyled variant
        if (this.props.unstyled) {
            return showCurrencySymbolAtStart
                ? <span>{currencySymbol}{formattedPrice}</span>
                : <span>{formattedPrice}{currencySymbol}</span>;
        }

        return (
            <div className={"text-primary-dark" + (this.props.classes ? " " + this.props.classes : "")}>
                <span className={(this.props.largePreText ? "text-lg" : "text-base") + (this.props.textBottom ? " align-bottom" : "")}>
                    {this.props.preText} {" "}
                </span>

                {(!this.props.hideCurrencySymbol && showCurrencySymbolAtStart) &&
                <span className={"text-xl font-bold" + (this.props.textBottom ? " align-bottom" : "") + strikethrough}> {currencySymbol}</span>
                }

                <span className={"text-4xl font-bold" + (this.props.textBottom ? " align-bottom" : "") + strikethrough}>{formattedPrice}</span>

                {(!this.props.hideCurrencySymbol && !showCurrencySymbolAtStart) &&
                <span className={"text-xl font-bold" + (this.props.textBottom ? " align-bottom" : "") + strikethrough}>{currencySymbol} {" "}</span>
                }

                <span className={(this.props.largePostText ? "text-lg" : "text-base") + (this.props.textBottom ? " align-bottom" : "")}>
                    {this.props.postText}
                </span>
            </div>
        )
    }
}

export default Price;